import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "transmission"
const TransmissionIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M20 2a2.998 2.998 0 0 1 1 5.825V10a3 3 0 0 1-3 3h-5v3.174A2.998 2.998 0 0 1 12 22a3 3 0 0 1-1-5.826V13H5v3.174A2.998 2.998 0 0 1 4 22a3 3 0 0 1-1-5.826V7.825A2.998 2.998 0 0 1 4 2a2.998 2.998 0 0 1 1 5.825V11h6V7.825A2.998 2.998 0 0 1 12 2a2.998 2.998 0 0 1 1 5.825V11h5a1 1 0 0 0 1-1V7.825A2.998 2.998 0 0 1 20 2" />
        </svg>
      }
    </span>
  )
}
export default TransmissionIcon
